import { useQueryClient } from '@tanstack/react-query';
import { getInvitesCountKey } from '../../../services/modules/invites/invites.keys';
import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';

const useInvalidateInvitesCount = () => {
  const queryClient = useQueryClient();
  const { team } = useApplicationContext();

  const invalidateInvitesCount = () => {
    queryClient.invalidateQueries({ queryKey: [team?.id, ...getInvitesCountKey()] });
  };

  return { invalidateInvitesCount };
};

export default useInvalidateInvitesCount;
